// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { EnvironmentConfig, version } from './_environment';

export const environment: EnvironmentConfig = {
	production: false,
	version,
	language: 'enCa',
	api: {
		autoAuthenticate: true,
		allowGuest: false,
		spoke: "dorwin",
	},
	sliceMap: {
		// 51371: 'HR_PROFILE', // a 'wtg' spoke var, provided as an example
	}
};
